<script lang="ts">
  import clsx from 'clsx';
  import { ButtonLink } from '@athena-lib/Button';
  import Cross from '@athena-lib/Icons/Cross.svelte';
  import SideScrollableContent from './SideScrollableContent.svelte';

  const {
    categories = [],
    selectedCategories = [],
  }: {
    categories?: Array<{ title: string; url: string }>;
    selectedCategories?: Array<{ title: string; url: string }>;
  } = $props();
</script>

{#if categories.length > 0 || selectedCategories.length > 0}
  <SideScrollableContent class={clsx('items-center gap-2 max-xl:pl-2')}>
    {#each selectedCategories as selectedCategory}
      <ButtonLink
        class="flex flex-row items-center gap-2"
        color="brand"
        size="small"
        link={{ href: selectedCategory.url }}
        ><span>{selectedCategory.title}</span>
        <Cross sizeClass={clsx('h-4')}></Cross></ButtonLink
      >
    {/each}
    {#each categories as category}
      <ButtonLink color="white" size="small" link={{ href: category.url }} class="shrink-0"
        >{category.title}</ButtonLink
      >
    {/each}
  </SideScrollableContent>
{/if}
